<template>
	<div class="inline-box">
		<span @click="openHelp">
			<svg-icon icon-class="cj-icon-help" style="cursor: pointer;"/>
		</span>
		<el-drawer ref="drawer" :modal-append-to-body="false" :withHeader="false" :size=400 :visible.sync="drawer" direction="rtl">
			<Help ref="Help" @close="drawer=false"/>
		</el-drawer>
	</div>
</template>

<script>
import Help from '@/components/Help';

export default {
	name: 'HelpTip',
	components: {
		Help
	},
	data() {
		return {
			drawer: false
		}
	},
	computed: {
	},
	methods: {
		openHelp(){
			this.drawer = true;
			this.$nextTick(()=>{
				this.$refs.Help.requestVersionHistory();
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.inline-box{
	display: inline-block;
	padding: 0 8px;
	font-size: 20px;
	vertical-align: text-bottom;
}

</style>
